import { useMutation } from "@tanstack/react-query";
import api from "apis";

const useUserDeleteByAdminMutation = () => {
  return useMutation({
    mutationFn: api.user.deactivateUserByAdmin,
  });
};

export default useUserDeleteByAdminMutation;
